( function() {
    'use strict';

    angular
        .module( 'ccsTrApp' )
        .factory( 'LotDTO', LotDTO );

    LotDTO.$inject = [ '$resource', 'DateUtils' ];

    function LotDTO( $resource, DateUtils ) {
        var resourceUrl = "api/lotDTO/:id";

        return $resource( resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lotCreatedOn = DateUtils.convertDateTimeFromServer(data.lotCreatedOn);
                        data.lotModifiedOn = DateUtils.convertDateTimeFromServer(data.lotModifiedOn);
                        data.lotLoadingDate = DateUtils.convertLocalDateFromServer(data.lotLoadingDate);
                    }
                    return data;
                }
            }
        });
    }
})();
